import React, {useEffect} from 'react'
import SEO from '../components/SEO'
import HeaderV2 from '../components/HomePageV2/HeaderV2'
import HeroV2 from '../components/HomePageV2/HeroV2'
import TopBrokeragesV2 from '../components/HomePageV2/TopBrokeragesV2'
import FeaturesV2 from '../components/HomePageV2/FeaturesV2'
import PricingV2 from '../components/HomePageV2/PricingV2'
import FaqV2 from '../components/HomePageV2/FaqV2'
import FinalCtaV2 from '../components/HomePageV2/FinalCtaV2'
import FooterV2 from '../components/HomePageV2/FooterV2'
import SignupFormMob from '../components/SignupFormMob'
import listingManagementLogo from '../images/icons/listing-management-logo.svg'
import config from '../config/index'
import '../components/HomePageV2/styles.css'

function SignupModal() {
  const closeModal = () => {
    window.location.hash = ''
  }

  useEffect(() => {
    const syncBodyScroll = () => {
      document.body.style.overflow = window.location.hash === '#signup-mod' ? 'hidden' : ''
    }

    syncBodyScroll()
    window.addEventListener('hashchange', syncBodyScroll)

    return () => {
      window.removeEventListener('hashchange', syncBodyScroll)
      document.body.style.overflow = ''
    }
  }, [])

  return (
    <div className="modal hlm-signup-modal signup-mods" id="signup-mod">
      <a href="#" className="modal-overlay hlm-signup-modal-overlay" aria-label="Close" />
      <div className="modal-container hlm-signup-modal-card" role="dialog" aria-modal="true" aria-labelledby="signup-title">
        <div className="hlm-signup-modal-glow" aria-hidden="true" />
        <button type="button" className="hlm-signup-modal-close" aria-label="Close" onClick={closeModal}>
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true">
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
        <div className="hlm-signup-modal-content">
          <img className="hlm-signup-modal-logo" src={listingManagementLogo} alt="HomeLight Listing Management" />
          <h2
            id="signup-title"
            className="hlm-modal-title"
            style={{
              margin: 0,
              fontSize: 'clamp(26px, 4.4vw, 32px)',
              fontWeight: 800,
              letterSpacing: '-0.02em',
              lineHeight: 1.1,
              color: 'rgb(39, 54, 83)',
            }}>
            Getting started is <span className="hlm-modal-title-highlight">easy — and free.</span>
          </h2>
          <p className="hlm-modal-sub">Enter the email you would like to use as your main account login.</p>
          <div className="hlm-signup-modal-form-wrap">
            <label className="hlm-signup-modal-label" htmlFor="hlm-signup-email">
              WORK EMAIL
            </label>
            <SignupFormMob size="md" className="hlm-signup-modal-form" inputId="hlm-signup-email" />
          </div>
          <div className="hlm-signup-modal-trust" aria-label="Signup benefits">
            <span>
              <span className="hlm-signup-modal-check" aria-hidden="true">
                ✓
              </span>
              14-day free trial
            </span>
            <span>
              <span className="hlm-signup-modal-check" aria-hidden="true">
                ✓
              </span>
              No credit card
            </span>
            <span>
              <span className="hlm-signup-modal-check" aria-hidden="true">
                ✓
              </span>
              Cancel anytime
            </span>
          </div>
          <p className="hlm-signup-modal-signin-copy">
            Already have an account?{' '}
            <a href={`${config.appUrl}/auth/login`} target="_blank" rel="noreferrer">
              Log in here
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}

function HomePageV2({homePath = '/'}) {
  return (
    <div className="hlm-page">
      <SEO
        title="HomeLight Listing Management - Run every listing from one place."
        meta={[
          {
            name: 'description',
            content:
              'Win more listings, handle every step without switching tools, and get your sellers the best deal. Start free or try Pro for 14 days.',
          },
          {property: 'og:title', content: 'HomeLight Listing Management'},
          {
            property: 'og:description',
            content: 'Run every listing from one place. Disclosures, buyer activity, offers, and listing marketing — in one secure platform.',
          },
          {property: 'og:type', content: 'website'},
        ]}
      />
      <HeaderV2 homePath={homePath} />
      <HeroV2 homePath={homePath} />
      <TopBrokeragesV2 />
      <FeaturesV2 />
      <PricingV2 />
      <FaqV2 />
      <FinalCtaV2 />
      <FooterV2 homePath={homePath} />
      <SignupModal />
    </div>
  )
}

export default HomePageV2
